import { defaultState as state, mutations } from './mutations';
import { actions } from './actions';

// TODO: replace with composables (1 day)
const inviteStore = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default inviteStore;
